import { Bot } from 'lucide-react';

const LoadingScreen = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-br from-indigo-50 via-white to-blue-50">
      <div className="text-center">
        <div className="relative">
          <div className="w-20 h-20 mx-auto mb-6 rounded-3xl overflow-hidden bg-gradient-to-br from-indigo-100 to-green-100 p-1 animate-pulse">
            <div className="w-full h-full rounded-3xl overflow-hidden bg-white flex items-center justify-center">
              <Bot className="w-10 h-10 text-indigo-400" />
            </div>
          </div>
          <div className="absolute inset-0 w-20 h-20 mx-auto rounded-3xl border-4 border-indigo-200 border-t-indigo-600 animate-spin"></div>
        </div>
        <p className="text-xl text-gray-700 font-medium">Preparando seu funcionário digital...</p>
        <p className="text-sm text-gray-500 mt-2">Isso levará apenas alguns segundos</p>
      </div>
    </div>
  );
};

export default LoadingScreen;